const CATEGORY_MAX_AGE = {
  'U13 Boys': 13,
  'U15 Boys': 15,
  'U17 Boys': 17,
};

function calculateAge(dob, cutoffDate) {
  let age = cutoffDate.getFullYear() - dob.getFullYear();
  const monthDiff = cutoffDate.getMonth() - dob.getMonth();
  const dayDiff = cutoffDate.getDate() - dob.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }
  return age;
}

export function checkEligibility(dob, category, cutoffDate = new Date()) {
  const birthDate = new Date(dob);
  const age = calculateAge(birthDate, cutoffDate);

  if (category === 'Girls') {
    return { eligible: true, age, reason: 'No age restriction for this category' };
  }

  const maxAge = CATEGORY_MAX_AGE[category];
  if (!maxAge) {
    return { eligible: false, age, reason: 'Unknown category' };
  }

  if (age <= maxAge) {
    return { eligible: true, age, reason: `Eligible for ${category}` };
  }

  return {
    eligible: false,
    age,
    reason: `Player is over the permitted age for ${category}`,
  };
}